import { render, staticRenderFns } from "./TaskboardCharts.vue?vue&type=template&id=34262a1a"
import script from "./TaskboardCharts.vue?vue&type=script&lang=js"
export * from "./TaskboardCharts.vue?vue&type=script&lang=js"
import style0 from "./TaskboardCharts.vue?vue&type=style&index=0&id=34262a1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports